<div class="bottom-line" [ngStyle]="{'padding-bottom': files.length || addObservation ? '8px' : '0'}">
  <ion-item-sliding>
    <ion-item lines="none">
      <ion-label class="ion-text-wrap ion-no-margin" [ngStyle]="{'margin-bottom': addObservation ? '0' : '10px'}">
        <ion-text color="dark">
          <ion-row>
            <ion-col size="8" class="fail">
              <div class="fail-status"></div>
              <strong>
                {{ flaw.enclosure }}
              </strong>
              <ion-text color="dark">
                <p class="config">{{ flaw.itemSpot }} / {{ flaw.failDetail }}
              </ion-text>
            </ion-col>
            <ion-col size="4" class="ion-text-end fail">
              <ion-icon class="icons clickable ion-padding-end" name="chatbubbles-outline" (click)="showObsInput()">
              </ion-icon>
              <ion-icon *ngIf="plt != 'desktop'" class="icons ion-padding-end"
                (click)="getPicture(camera.PictureSourceType.CAMERA)" name="camera-outline"></ion-icon>
              <ion-icon class="icons clickable" (click)="openOptions()" name="ellipsis-vertical"></ion-icon>
            </ion-col>
          </ion-row>
        </ion-text>
        <ion-text *ngIf="!addObservation && flaw.observation !== 'Sin observación'" color="medium"
          (click)="showObsInput()">
          <small>{{ flaw.observation }}</small>
        </ion-text>
      </ion-label>
    </ion-item>
    <ion-item-options side="end">
      <ion-item-option (click)="deleteFlaw()" color="danger">
        <ion-icon slot="end" name="trash"></ion-icon>
      </ion-item-option>
    </ion-item-options>
  </ion-item-sliding>

  <ion-item *ngIf="addObservation" class="ion-margin-start ion-margin-end"
    [ngClass]="{'ion-margin-bottom': files.length}">
    <ion-textarea class="obs-textarea" rows="1" #input (keyup)="saveObservation($event)" (ionBlur)="saveObservation()"
      [(ngModel)]="observation" placeholder="{{ 'addedd-flaw.Agregar observación'  | translate }}" minlength="1"
      maxlength="500" value="" required>
    </ion-textarea>
    <small class="obsCharsCount">{{ obsCharsCount }}/500</small>
    <ion-button (click)="saveObservation()" fill="clear" color="primary" type="button" class="send-btn">
      <ion-icon name="send"></ion-icon>
    </ion-button>
  </ion-item>

  <ng-container *ngIf="files.length">
    <div class="img-container">
      <cc-images [imgs]="files" (clickedImg)="openFile($event)" (tapedImg)="deleteFile($event)">
      </cc-images>
    </div>
  </ng-container>
</div>

<input #file type="file" style="display: none;" (change)="selectedFileBrowser(file.files[0])">